exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\na[data-v-8cfe374a] {\n  cursor: pointer;\n}\n.responsive-img[data-v-8cfe374a] {\n  max-width: 400px;\n  margin: 0 30px;\n}\n.reset-password-message[data-v-8cfe374a] {\n  padding: 20px 20px 10px;\n  background: rgb(255, 220, 220);\n  border: 2px solid rgb(255, 100, 100);\n  border-radius: 20px;\n  font-weight: 600;\n  max-width: 660px;\n  margin: 50px auto 0;\n  text-align: justify;\n}\n.reset-password-message > ul > li[data-v-8cfe374a] {\n  list-style-type: disc;\n  margin-left: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-8cfe374a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Splash.vue
// module id = 429
// module chunks = 1